const Cookie = require('react-cookie').Cookies;
const cookieParams = require('../../utils/cookieParams');

const cookie = new Cookie();
const onInitialClientRender = () => {
  if (window.location.search) {
    window.location.search
      .replace('?', '')
      .split('&')
      .forEach((param) => {
        cookie.set(param, param, cookieParams);
        return undefined;
      });
  }

  cookie.set('referrer', document.referrer, cookieParams);
  cookie.set('landingPage', window.location.href, cookieParams);
};

module.exports = onInitialClientRender;
